import styled from "styled-components";
import { BoxType } from ".";
import "../../styles/variables.css";

const mapTypeColors = (type: string) => {
  if (type === BoxType.FLAT) {
    return `
        background-color: var(--white);
        border: 1px solid var(--bg-box);
        `;
  }
  if (type === BoxType.INFO) {
    return `
        background-color: var(--bg-info-alert);
        border: 1px solid transparent;
        `;
  }
  if (type === BoxType.ERROR) {
    return `
        background-color: var(--bg-error-alert);
        border: 1px solid var(--border-error);
        span {
          color: var(--border-error);
        }
        `;
  }
  if (type === BoxType.ROUNDED_BORDER) {
    return `
        background-color: var(--bg-info-alert);
        border: 1px solid var(--bg-box);
        border-radius: 22px !important;
        `;
  }
};

export const BoxContainer = styled.div<{
  width?: string;
  height?: string;
  padding?: string;
  margin?: string;
  type: BoxType;
}>`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "initial"};
  padding: ${(props) => props.padding || "16px"};
  margin: ${(props) => props.margin || "0px"};
  box-sizing: border-box;
  border-radius: 16px;
  font-weight: 500;
  ${(props) => mapTypeColors(props.type)}

  & + & {
    margin-top: 16px;
  }
`;
